import React from 'react';
import { TickCircle } from '../../../Icons';
import { useAuth } from '../../AuthContextProvider';

export default function RegisterDetailsSidebar() {
  const {
    config: { sidebarItems },
  } = useAuth();
  return (
    <div className="h-full bg-gray-850 w-2/6 max-w-md rounded-r-xl shadow-lg p-4 flex justify-center items-center flex-col flex-shrink-0">
      {sidebarItems.map((item, key) => (
        <div key={key} className="flex justify-start text-white px-8 mb-8">
          <TickCircle
            className="w-5 h-5 mr-3 flex-shrink-0 text-green-600 block mt-1"
            size={20}
          />
          <div className="">
            <h2 className="text-lg font-medium">{item.title}</h2>
            <p className="text-sm font-light opacity-50">{item.message}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
